import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { listFlowsQuery } from '@/queries/flow.query'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import type { FlowConnectionNodeData } from '../../../../nodes/flow-connection-node/flow-connection.node'
import type { BuilderNodeType } from '../../../../types'

type FlowConnectionPropertyPanelProps = Readonly<{
  id: string
  type: BuilderNodeType
  data: FlowConnectionNodeData
  updateData: (data: Partial<FlowConnectionNodeData>) => void
}>

export default function FlowConnectionPropertyPanel({
  id,
  data,
  updateData,
}: FlowConnectionPropertyPanelProps) {
  const { data: flows } = useQuery(listFlowsQuery)
  const options = useMemo(() => flows ?? [], [flows])

  return (
    <div className='flex flex-col gap-4 p-4'>
      <div className='-mb-4 self-end text-xs text-card-foreground/20'>{id}</div>

      <div className='grid grid-cols-1 gap-2'>
        <div>
          <Label className='mb-1 block text-xs'>Selecionar fluxo</Label>
          <Select
            value={data.targetFlowId ? String(data.targetFlowId) : ''}
            onValueChange={(v) => {
              const next = options.find((f) => String(f.id) === v)
              updateData({
                targetFlowId: next ? next.id : null,
                targetFlowName: next?.name,
              })
            }}
          >
            <SelectTrigger className='h-8'>
              <SelectValue placeholder='Escolha um fluxo' />
            </SelectTrigger>
            <SelectContent>
              {options.map((flow) => (
                <SelectItem key={flow.id} value={String(flow.id)}>
                  #{flow.id} - {flow.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  )
}
